
(() => {
  if (window.__stetsonGiftLoaded) return;
  window.__stetsonGiftLoaded = true;

  const config = window.stetsonGiftConfig || {};
  const giftId = Number(config.variantId);
  const root = window.Shopify?.routes?.root || '/';

  if (!giftId) {
    console.error('[STETSON] Brak Variant ID pudełka');
    return;
  }

  const nativeFetch = window.fetch.bind(window);
  let busy = false;
  let timer = null;

  const url = path => root + path;

  async function getCart() {
    const res = await nativeFetch(url('cart.js'), {
      cache: 'no-store'
    });
    if (!res.ok) throw new Error('Cart read error');
    return res.json();
  }

  async function changeCart(path, data) {
    const res = await nativeFetch(url(path), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(data)
    });

    if (!res.ok) {
      throw new Error(await res.text());
    }

    return res.json();
  }

  function eligible(item) {
    return (
      item.vendor?.trim().toLowerCase() === 'stetson' &&
      item.product_type?.trim().toLowerCase() === 'trucker cap' &&
      Number(item.variant_id) !== giftId
    );
  }

  async function refreshDrawer() {
    const res = await nativeFetch(
      url('?sections=cart-drawer,cart-icon-bubble'),
      { cache: 'no-store' }
    );

    if (!res.ok) return;

    const sections = await res.json();
    const parser = new DOMParser();

    const drawer = document.querySelector('cart-drawer');

    if (drawer && sections['cart-drawer']) {
      const doc = parser.parseFromString(
        sections['cart-drawer'],
        'text/html'
      );

      const updated = doc.querySelector('cart-drawer');
      const oldInner = drawer.querySelector('.drawer__inner');
      const newInner = updated?.querySelector('.drawer__inner');

      if (oldInner && newInner) {
        oldInner.replaceWith(newInner);
      }

      drawer.classList.toggle(
        'is-empty',
        updated?.classList.contains('is-empty') || false
      );
    }

    const bubble = document.getElementById('cart-icon-bubble');

    if (bubble && sections['cart-icon-bubble']) {
      const doc = parser.parseFromString(
        sections['cart-icon-bubble'],
        'text/html'
      );

      const updated = doc.getElementById('cart-icon-bubble');

      if (updated) {
        bubble.innerHTML = updated.innerHTML;
      }
    }
  }

  function showNotice() {
    document.getElementById('stetson-gift-toast')?.remove();

    const toast = document.createElement('div');
    toast.id = 'stetson-gift-toast';
    toast.setAttribute('role', 'status');

    toast.innerHTML = `
      <strong>🎁 GRATULERER! GRATIS STETSON-BOX!</strong>
      <p>Gaveboksen er lagt til i handlekurven din.</p>
    `;

    Object.assign(toast.style, {
      position: 'fixed',
      bottom: '20px',
      right: '20px',
      zIndex: '999999',
      padding: '20px',
      maxWidth: '340px',
      background: '#153e37',
      color: '#ffffff',
      borderRadius: '12px',
      boxShadow: '0 8px 30px rgba(0,0,0,.2)'
    });

    document.body.appendChild(toast);
    setTimeout(() => toast.remove(), 5000);
  }

  async function syncGift() {
    if (busy) return;
    busy = true;

    try {
      const cart = await getCart();

      const count = cart.items
        .filter(eligible)
        .reduce((sum, item) => sum + item.quantity, 0);

      const gifts = cart.items.filter(
        item => Number(item.variant_id) === giftId
      );

      const shouldHaveGift = count >= 3;
      let changed = false;
      let added = false;

      console.log('[STETSON] Czapki:', count);
      console.log('[STETSON] Pudełko:', giftId);

      if (shouldHaveGift && gifts.length === 0) {
        await changeCart('cart/add.js', {
          items: [{
            id: giftId,
            quantity: 1,
            properties: {
              _stetson_gift: 'free'
            }
          }]
        });

        changed = true;
        added = true;
      }

      let keep = shouldHaveGift;

      for (const gift of gifts) {
        const target = keep ? 1 : 0;
        keep = false;

        if (gift.quantity !== target) {
          await changeCart('cart/change.js', {
            id: gift.key,
            quantity: target
          });

          changed = true;
        }
      }

      if (changed) {
        await refreshDrawer();
      }

      if (added) {
        showNotice();
      }

    } catch (error) {
      console.error('[STETSON GIFT ERROR]', error);
    } finally {
      busy = false;
    }
  }

  function scheduleSync() {
    clearTimeout(timer);
    timer = setTimeout(syncGift, 700);
  }

  window.stetsonGiftSync = scheduleSync;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSync);
  } else {
    scheduleSync();
  }

  window.addEventListener('pageshow', scheduleSync);

  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, scheduleSync);
  }

  window.fetch = async function(...args) {
    const response = await nativeFetch(...args);

    const requestUrl = String(
      typeof args[0] === 'string'
        ? args[0]
        : args[0]?.url || ''
    );

    if (
      response.ok &&
      /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(requestUrl)
    ) {
      scheduleSync();
    }

    return response;
  };
})();
